// @ts-nocheck

import { MenuActionTypes } from '../types/actions/common';
import type { MenuActionType } from '../types/actions/common';
import type { MenuKeyType } from '../types/common';

/**
 * Create an action to add an opened key to the corresponding menu
 *
 * @return {Object} Return an action object
 */

type MenuAddKeyAction = {
  type: MenuActionType;
  payload: {
    type: MenuKeyType;
    key: string | number;
  };
};
export type MenuAddKeyType = (type: MenuKeyType, key?: string | number | null) => MenuAddKeyAction;
const menuAddKey = (type: MenuKeyType, key?: string | number | null): MenuAddKeyAction => ({
  type: MenuActionTypes.ADD_KEY,
  payload: {
    type,
    key,
  },
});

type MenuSetKeyAction = {
  type: MenuActionType;
  payload: {
    type: MenuKeyType;
    key: string | number;
  };
};
export type MenuSetKeyType = (type: MenuKeyType, key?: string | number | null) => MenuSetKeyAction;
const menuSetKey = (type: MenuKeyType, key?: string | number | null): MenuSetKeyAction => ({
  type: MenuActionTypes.SET_KEY,
  payload: {
    type,
    key,
  },
});

type MenuResetAction = {
  type: MenuActionType;
};
export type MenuResetType = () => MenuResetAction;
const menuReset = (): MenuResetAction => ({
  type: MenuActionTypes.RESET,
});

export default {
  menuReset,
  menuSetKey,
  menuAddKey,
};
